<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.import.multi.matches.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<div class="row mb-sm-3">
			<div class="col">
				<span jhiTranslate="germplasm-list.import.multi.matches.description" [translateValues]="{param1: rowNumber, param2: name, param3: matchNumber, param4: unassignedCount}"></span>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-curved">
						<thead>
                        <tr>
						<th>GID</th>
						<th>{{ getStaticColumnLabelKey(STATIC_COLUMN_DESIGNATION) | translate }}</th>
						<th>{{ getStaticColumnLabelKey(STATIC_COLUMN_CROSS) | translate }}</th>
						<th>{{ getStaticColumnLabelKey(STATIC_COLUMN_LOCATION_NAME) | translate }}</th>
						<th>{{ getStaticColumnLabelKey(STATIC_COLUMN_BREEDING_METHOD_NAME) | translate }}</th>
						<th>{{ getStaticColumnLabelKey(STATIC_COLUMN_CREATED_DATE) | translate }}</th>
                        </tr>
						</thead>
						<tbody>
						<tr [@tableAnimation] *ngFor="let germplasm of matches | slice: (page-1) * pageSize : page * pageSize"
							[class.selected]="selectMatchesResult[dataRow[HEADERS.ROW_NUMBER]] == germplasm.gid"
							(click)="onSelectMatch(germplasm)">
							<td><a class="link" [href]="germplasmDetailsUrlService.getUrl(germplasm.gid)" target="_blank">{{germplasm.gid}}</a></td>
							<td><a class="link" [href]="germplasmDetailsUrlService.getUrl(germplasm.gid)" target="_blank">{{germplasm.preferredName}}</a></td>
							<td>{{germplasm.pedigreeString}}</td>
							<td>{{germplasm.breedingLocation}}</td>
							<td>{{germplasm.breedingMethod}}</td>
							<td>{{germplasm.creationDate}}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="matches.length" [itemsPerPage]="pageSize"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="matches.length" [(page)]="page" [pageSize]="pageSize"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col">
						<div class="form-check form-check-inline">
							<input type="checkbox" class="form-check-input" name="" id="matchAllOccurrences"
								   [(ngModel)]="useSameMatchForAllOccurrences" (change)="checkUseSameMatchForAllOcurrences()">
							<label class="form-check-label" for="matchAllOccurrences" jhiTranslate="germplasm-list.import.review.use.same.match.for.all.ocurrences">
								match for all occurrences of the name
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button *ngIf="matchNumber === 1" type="button" class="btn btn-secondary" data-bs-dismiss="modal"
			(click)="dismiss()">
		<span jhiTranslate="cancel"></span>
	</button>
	<button *ngIf="matchNumber > 1" type="button" class="btn btn-secondary"
			(click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button type="button" class="btn btn-primary" (click)="ignoreMatch()">
		<span jhiTranslate="omit"></span>
	</button>
	<button (click)="next()" class="btn btn-primary" [disabled]="!(isIgnoreMatch|| selectMatchesResult[dataRow[HEADERS.ROW_NUMBER]])">
	<span *ngIf="isFinish(); else nextButton" jhiTranslate="next"></span>
		<ng-template #nextButton><span jhiTranslate="next"></span></ng-template>
	</button>
</div>
